// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofLine-cls1_UL7","cls2":"SocialProofLine-cls2_g-1 SocialProofLine-cls1_UL7"};